import React from 'react';
import SalesFileFormContainer from '../../../containers/projectmng/purchaseorder/SalesFileFormContainer';
import SalesFileListContainer from '../../../containers/projectmng/purchaseorder/SalesFileListContainer';
import DetailTemplate from '../../common/template/DetailTemplate';

const PurchaseOrderTemplate = () => {
  return (
    <DetailTemplate title="받은 발주서">
      <SalesFileListContainer />
      <SalesFileFormContainer />
    </DetailTemplate>
  );
};

export default PurchaseOrderTemplate;
